import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import i18n from 'i18next';
import { useTranslation } from "react-i18next";
import { Radio } from 'antd';

import useAuthAdminStore from "../store/useAuthAdminStore";
import Flex from "../components/core/Flex";
import HeaderBar from "../components/admin/HeaderBar";
import FormHeader from "../components/form/FormHeader";
import FormTitle from "../components/form/FormTitle";

function AdminSetting() {
  const navigate = useNavigate();
  const { firstName, lastName, role } = useAuthAdminStore();
  const { t } = useTranslation();

  return (
    <PageAdminSetting>
      <HeaderBar title={t("translation:admin.portal_name")} name={`${firstName} ${lastName}`} role={role} />

      <Container>
        <MainContainer>
          <FormHeader>{t("translation:admin.setting.title")}</FormHeader>

          <Flex gap={32}>
            <FormTitle>{t("translation:admin.setting.language")}</FormTitle>
            <Radio.Group defaultValue={i18n.language} buttonStyle="solid" onChange={() => {
              i18n.changeLanguage(i18n.language === "ch" ? "en" : "ch");
              navigate(`${process.env.PUBLIC_URL}/${i18n.language}/admin/setting`, { replace: true });
            }}>
              <Radio.Button value="ch">{t("translation:admin.setting.ch")}</Radio.Button>
              <Radio.Button value="en">{t("translation:admin.setting.en")}</Radio.Button>
            </Radio.Group>
          </Flex>
        </MainContainer>
      </Container>
    </PageAdminSetting >
  );
}

const PageAdminSetting = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  gap: 0px;
`;

const Container = styled(Flex)`
  width: 100%;
  height: 100%;
  background-color: var(--aia-bx-gray-10);
  align-items: flex-start;
  gap: 0px;
`;

const MainContainer = styled(Flex)`
  width: 100%;
  height: calc(100vh - 66px);
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 36px 24px;
  gap: 24px;
`;

export default AdminSetting;